module.exports = __webpack_public_path__ + "img/panel11.3dc86fd4.jpg";